<!--START: header-->
<landing-app-header *ngIf="userRole == null"></landing-app-header>
<!--END: header-->

<div [ngClass]="{'without-login' : userRole == null}">
  <div class="content-blk product-to-design" [ngClass]="{'container' : userRole == 'SuperAdmin'}">
    <div class="container">
      <div class="row">
        <div class="col-md-6">
          <h5 class="page-title">
            Product Details
            <span class="clearfix"></span>
          </h5>
        </div>
        <div class="col-md-6">
          <a class="pull-right text-danger" (click)="fn_gotoPreviousPage()" href="javascript:void(0)">
            <i class="fa fa-arrow-left" aria-hidden="true"></i>
            Back
          </a>
        </div>
      </div>

      <span class="ribbon-main ribbon-main-{{productDetails.ProductAdditionalInfo.ProductType}}"
        *ngIf="productDetails.ProductAdditionalInfo != null">
        {{productDetails.ProductAdditionalInfo.ProductType}}
      </span>
      <div class="white-background" *ngIf="productDetails">
        <div class="addit-info-not-found" *ngIf = "productDetails?.ProductAdditionalInfo == null">
          <p>*Product Additional Info Not Found, Please Add It Through Spreadsheet.</p>
        </div>
        <div class="start-design">
          <a *ngIf="userRole === 'StoreAdmin' || userRole === 'StoreOwner' || userRole === 'StoreStaffMember'"
            (click)="fn_CustomizeProduct()">
            <i class="fa fa-paint-brush"></i>&nbsp;Start designing
          </a>
        </div>
        <div class="row dtl-prdct">
          <div class="col-md-5">
            <div class="prdt-dt-bx">
              <span [ngClass]="productDetails?.CustomizationType?.length < 13 ? (productDetails?.CustomizationType?.length < 10 ? (productDetails?.CustomizationType?.length < 7 ? 'dec-type5' : 'dec-type7') : 'dec-type10') : 'dec-type13'" >
                {{productDetails?.CustomizationType}}
              </span>

              <div class="prdt-dt-nbx" style="position: relative;">
                <img id="file-image" [src]="imageSrc || 'assets/img/load.gif'" alt="Preview">
              </div>
              <div class="main-pro-bottom-img-bottm prdt-btm-lx">
                <ul>
                  <li *ngFor="let img of imageList" (click)="selectProductStyle(img)">
                    <div>
                      <img src="{{img || 'assets/img/load.gif'}}" alt="" />
                    </div>
                  </li>
                </ul>
              </div>

            </div>
          </div>
          <div class="col-md-7">
            <div>
              <div class="dtl-content">
                <div class="dtl-top">
                  <div class="rt-ttl-head">
                    <h4>
                      {{productDetails.Name}}
                    </h4>
                  </div>
                </div>
                <div *ngIf="productDetails.ProductAdditionalInfo?.Label" class="row label-row">
                  <ng-container *ngFor="let label of getLabelArray(productDetails.ProductAdditionalInfo.Label)">
                    <div class="col-md-2 label-col text-center">
                      {{ label.trim() }}
                    </div>
                  </ng-container>
              </div>
              <div *ngIf="productDetails.ProductAdditionalInfo == null" class="row label-row">
                <ng-container>
                  <div class="col-md-2 label-col text-center">
                   No Label
                  </div>
                </ng-container>
            </div>
                <div class="product-detail">
                  <h5 class="mt-1">
                    Description:
                    <small [innerHTML]="productDetails.LongDescription"></small>
                  </h5>
                </div>
                <ng-container *ngIf="productDetails.ProductAdditionalInfo">
                  <div class="product-detail">
                    <h5>
                      Made in:
                      <small>{{productDetails.ProductAdditionalInfo.MadeIn}}</small>
                    </h5>
                  </div>
                  <div class="product-detail">
                    <h5>
                      Composition:
                      <small>{{productDetails.ProductAdditionalInfo.Composition}}</small>
                    </h5>
                  </div>
                </ng-container>
                <ng-container *ngIf="productDetails.ProductAdditionalInfo == null">
                  <div class="product-detail">
                    <h5>
                      Made in:
                      <small style="color: red; font-weight: bold;">N/A</small>
                    </h5>
                  </div>
                  <div class="product-detail">
                    <h5>
                      Composition:
                      <small style="color: red; font-weight: bold;">N/A</small>
                    </h5>
                  </div>
                </ng-container>
                <div class="product-detail">
                  <h5>Available sizes</h5>
                  <mat-button-toggle-group  name="sizes" aria-label="Sizes"
                  [hideSingleSelectionIndicator]="true">
                    <ul class="sz-lst-ul">
                      <li *ngFor="let size of sizeList">
                        <mat-button-toggle [value]="size.Name" [checked]="size.Name == currentSizeName"
                          (click)="fn_SelectSize(size.Name)">
                          {{size.Name}}
                        </mat-button-toggle>
                        <br>
                        <small class="sml-qty"> Qty: {{size.AvailableQty == null ? 'NA' : size.AvailableQty}} </small>
                      </li>
                    </ul>
                  </mat-button-toggle-group>
                </div>

                <div class="product-detail dv-cstmsed-prdct-dtls">
                  <h5 style="margin-top: 5px;">
                    Available colors
                    <small class="color-name" *ngIf="currentStyleName">{{currentStyleName}}</small>
                  </h5>
                  <mat-button-toggle-group name="color" aria-label="Color"
                    [hideSingleSelectionIndicator]="false">
                    <ul class="sz-lst-ul tick prdc-dtls-ul">
                      <li  *ngFor="let color of productDetails.Styles">
                        <mat-button-toggle  [value]="color.ID"
                          [checked]="color.ID == currentStyleUniqueId" [ngStyle]="displayColor('#'+color.HtmlColor1)"
                          (click)="selectStyle(color.ID)">
                        </mat-button-toggle>
                      </li>
                    </ul>
                  </mat-button-toggle-group>
                </div>

                <div class="product-detail">
                  <h5>
                    Price :
                    <strong>
                      {{currentPrice | currency:'USD':'symbol':'1.2-2' }}
                      <small style="font-size:12px;">per piece</small>
                    </strong>

                  </h5>

                  <h5 *ngIf="productDetails?.ProductAdditionalInfo?.ExpectedShipDate != null">
                    Expected ship date : <small class="smll-expshpdate">
                      {{productDetails?.ProductAdditionalInfo?.ExpectedShipDate}}</small>
                  </h5>
                  <h5 *ngIf="productDetails?.ProductAdditionalInfo?.ExpectedShipDate == null">
                    Expected ship date : <small class="smll-expshpdate" style="color: red; font-weight: bold;"> N/A</small> 
                  </h5>
                  <h5 *ngIf="IsEmbroideryType">
                    <small style="font-size:12px;">Embroidery Cost: {{EmbroideryCost}}</small><br />
                    <small style="font-size:12px;">Embroidery SetUp Cost: {{EmbroiderySetUpCost}}</small>
                  </h5>
                </div>

              </div>
            </div>
          </div>
        </div>


        <div class="row featureCare" *ngIf="productDetails.ProductFeatures.length > 0">
          <div class="col-md-4">
            <h4>
              <i class="fa fa-bookmark" aria-hidden="true"></i>&nbsp;Key features
            </h4>
          </div>
          <div class="col-md-8">
            <div class="row">
              <ng-container *ngFor="let feature of productDetails.ProductFeatures;">
                <div class="col-md-6">
                  <h6>
                    <span class="index">🗸</span>&nbsp;{{feature.Title}}
                  </h6>
                  <p>
                    {{feature.Description}}
                  </p>
                </div>
              </ng-container>
            </div>
          </div>
        </div>

        <div class="row featureCare" *ngIf="productDetails.ProductCareInstrictions.length > 0">
          <div class="col-md-4">
            <h4>
              <i class="fa fa-thumbs-up" aria-hidden="true"></i>&nbsp;Care instructions
            </h4>
          </div>
          <div class="col-md-8">
            <div class="row">
              <div class="col-md-8">
                <div *ngFor="let ins of productDetails.ProductCareInstrictions;">
                  <p>
                    <span class="index">🗸</span>&nbsp;{{ins.Instructions}}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row featureCare" *ngIf="productDetails.SizeGuides.length > 0">
          <div class="col-md-4">
            <h4>
              <mat-icon>straighten</mat-icon>
              Size guide
            </h4>
          </div>
          <div class="col-md-8">
            <div class="row">
              <div class="col-md-12">
                <mat-table #table [dataSource]="dataSource" class="mat-elevation-z8">

                  <ng-container *ngFor="let disCol of displayColumns; let colIndex = index" matColumnDef="{{disCol}}">
                    <mat-header-cell *matHeaderCellDef class="table-header">
                      <ng-container *ngIf="colIndex != 0">
                        {{disCol}}
                      </ng-container>
                    </mat-header-cell>

                    <mat-cell *matCellDef="let element " class="table-data">
                      {{element[disCol]}}
                    </mat-cell>
                  </ng-container>

                  <mat-header-row *matHeaderRowDef="displayColumns"></mat-header-row>
                  <mat-row *matRowDef="let row; columns: displayColumns;"></mat-row>
                </mat-table>
              </div>
            </div>
          </div>
        </div>

        <div class="featureCare" *ngIf="recommendationList && recommendationList.length > 0">
          <div class="row">
            <div class="col-sm-12">
              <h4>
                <i class="fa fa-heart" aria-hidden="true"></i>&nbsp;You may also like
              </h4>
            </div>
          </div>
          <br />
          <div class="row">
            <ng-container *ngFor="let product of recommendationList; index as i">
              <div *ngIf="product.IsActive" class="col-sm-3 col-md-3 product-sections store-item-thumb"
                (click)="gotoDetailPage(product.ProductId)">

                <div class="ribbon ribbon-{{product.ProductAdditionalInfo.ProductType}}"
                  *ngIf="product.ProductAdditionalInfo != null">
                  <span>
                    {{product.ProductAdditionalInfo.ProductType}}
                  </span>
                </div>
                <div class="img-selected">
                  <img class="slected-image" src="{{product.ImageUrl}}">
                </div>
                <div class="store-item-cntnt">
                  <h4>
                    {{product.Description.length > 40 ? (product.Description | slice:0:40) + '..'
                    :(product.Description)}}
                  </h4>
                  <small>Starting <span class="price">{{product.UnitCost |currency:'USD':'symbol':'1.2-2' }}</span>
                  </small>
                </div>

                <p class="available-sizes">
                  Size: <strong>{{product.Sizes}}</strong>
                </p>
                <div class="color-list">
                  <!--Conditional based isActive display-->
                  <ng-container *ngFor="let s of product.Styles">
                    <div matTooltip="{{s.Name}}" class="available-colors" *ngIf="s.IsActive"
                      [ngStyle]="displayColor('#' + s.HtmlColor1)">
                    </div>
                  </ng-container>
                  <!--Conditional based isActive display-->
                </div>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </div>

  </div>
  <br />
  <br />
</div>
<br />
<br />